// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QJXZ","selected":"styles_selected__2sW2M"};